import { Subject } from 'rxjs';
import { Injectable } from '@angular/core';
import { SidenavLink } from '../_models/SidenavLink';
import { AppAuthService } from './app-auth.service';
import { Permissions } from '../_enums/permissions';

@Injectable({
    providedIn: 'root'
})
export class SidenavService {
    sectionLinksSub = new Subject<SidenavLink[]>();
    navLinksSub = new Subject<SidenavLink[]>();

    constructor(private _appAuthService: AppAuthService) { }

    updateLinks(links: any[]) {
        this.createNavLinks();
        this.sectionLinksSub.next(links);
    }

    private createNavLinks() {
        const navLinks = [
            { name: 'Home', href: ['/'], icon: 'home' },
            { name: 'Orders', href: ['/orders'], icon: 'assignment' },
            { name: 'Receiving', href: ['/receiving'], icon: 'archive' },
            { name: 'Shipment', href: ['/shipment'], icon: 'local_shipping' },
            { name: 'Reconciliation', href: ['/recon'], icon: 'compare_arrows' },
            { name: 'Inventory', href: ['/inventory'], icon: 'view_module' },
            { name: 'Suppliers', href: ['/suppliers'], icon: 'contacts' },
            { name: 'Invoices', href: ['/invoices'], icon: 'folder_open' },
            { name: 'Payments', href: ['/payments'], icon: 'account_balance_wallet' },
        ];
        if (this._appAuthService.hasPermissions([Permissions.Purchaser])) navLinks.push({ name: 'Reports', href: ['/reports'], icon: 'visibility' });

        navLinks.push({ name: 'My Organization', href: ['/my-organization'], icon: 'groups' });

        if (this._appAuthService.hasPermissions([Permissions.Hr])) {
            navLinks.push({ name: 'Users', href: ['/users'], icon: 'lock' });
        }

        if (this._appAuthService.isSuperUser()) {
            navLinks.push({ name: 'Products', href: ['/product'], icon: 'lock' });
            navLinks.push({ name: 'Organizations', href: ['/organizations'], icon: 'lock' });
        }

        this.navLinksSub.next(navLinks.slice());
    }
}
